import type { RouterConfig } from '@nuxt/schema';

const devRoutes = [
  {
    name: 'playground',
    path: '/playground',
    component: () => import('~/pages/DevPlayground.vue'), // TODO verify it doesnt appear in production bundle
  },
  {
    path: '/',
    redirect: '/shop/product/vance-co.-mens-demar-casual-dress-shoes?ID=14153795&CategoryID=65',
  },
];

export default <RouterConfig>{
  routes: () => [
    {
      name: 'product',
      path: '/shop/product/:name(.*)',
      component: () => import('~/pages/ProductPage.vue'),
      meta: {
        noScroll: true,
      },
    },
    {
      name: 'productWithoutName',
      path: '/shop/product',
      component: () => import('~/pages/ProductPage.vue'),
      meta: {
        noScroll: true,
      },
    },
    {
      name: 'writeReview',
      path: '/shop/product/review/add',
      component: () => import('~/pages/WriteReviewPage.vue'),
    },
    ...(process.env.NODE_ENV === 'development' ? devRoutes : []),
  ],
};
